import { authReducer } from "./authReducer";
import { visibilityReducer } from "./visibilityReducer";
import { actionsPermissionsReducer } from "./actionsPermissionsReducer";
import { statusReducer } from "./statusReducer";
import { userInfoReducer } from "./userInfoReducer";
import { notificationReducer } from "./notificationReducer";
import { messageTemplateReducer } from "./messageTemplateReducer";

export default {
  authReducer,
  visibilityReducer,
  actionsPermissionsReducer,
  statusReducer,
  userInfoReducer,
  notificationReducer,
  messageTemplateReducer,
};
